export default __webpack_public_path__ + "static/media/coin.f7b1af08.svg";